import { MultiSelectMode } from '../../../types/types';

type BulkDetailExitParams = {
  datasetId: string;
  multiSelectMode: MultiSelectMode;
  isRootToken: boolean;
  isSubsetForm: boolean;
  fromUrl: string | undefined;
};

export const shouldReturnToListAfterBulkSubmit = ({
  datasetId,
  multiSelectMode,
  isRootToken,
  isSubsetForm,
  fromUrl,
}: BulkDetailExitParams): boolean => {
  if (!datasetId) return false;
  if (multiSelectMode !== 'bulk') return false;
  if (!isRootToken) return false;
  // Subset bulk edit keeps its detail return so the slave grid still relocates the row.
  if (isSubsetForm) return false;

  return fromUrl?.includes('/detail/') === true;
};
